import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["innerHTML"]


import { Article } from "@/data/index.type";

interface ArticleProps {
  data: Article;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Article',
  props: {
    data: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.$style.root)
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.$style.title)
    }, _toDisplayString(__props.data.title), 3),
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.$style.date)
    }, "发布时间：" + _toDisplayString(__props.data.releaseData), 3),
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.$style.content),
      innerHTML: __props.data.content
    }, null, 10, _hoisted_1)
  ], 2))
}
}

})